import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import GdaBadge from '../../svg/icons/gda_badge.svg';
import { getTranslation } from '../../providers/TranslationProvider';

import './PriorityNotify.scss';

const PriorityNotify = ({
  isPriorityNotify,
  setIsPriorityNotify,
  priorityNotifyVariables,
}) => (
  <div className="Notify__priority">
    <Icon
      component={GdaBadge}
      name="GDA-badge"
      height="40px"
      width="40px"
    />
    <div className="Notify__priority-copy">
      <div className="Notify__priority-title">
        {priorityNotifyVariables?.create_notify?.priority_toggle_view_title
          || getTranslation({ translationKey: 'priority_notify_title', fallback: 'Make it a priority' })}
      </div>
      <div className="Notify__priority-description">
        {priorityNotifyVariables?.create_notify?.priority_toggle_view_subtitle
          || getTranslation({ translationKey: 'priority_notify_subtitle', fallback: 'Exclusive for Global Dining Access Members' })}
      </div>
    </div>
    <button
      className="Notify__priority-toggle"
      type="button"
      role="switch"
      aria-checked={isPriorityNotify}
      aria-label={getTranslation({ translationKey: 'priority_notify_toggle', fallback: 'Make this notify a priority' })}
      onClick={() => setIsPriorityNotify(!isPriorityNotify)}
    >
      <span />
    </button>
  </div>
);

PriorityNotify.propTypes = {
  isPriorityNotify: PropTypes.bool,
  setIsPriorityNotify: PropTypes.func,
  priorityNotifyVariables: PropTypes.shape({
    create_notify: PropTypes.shape({
      priority_toggle_view_title: PropTypes.string,
      priority_toggle_view_subtitle: PropTypes.string,
    }),
  }),
};

PriorityNotify.defaultProps = {
  isPriorityNotify: false,
  setIsPriorityNotify: () => {},
  priorityNotifyVariables: {},
};

export default PriorityNotify;
